<template>

    <BasePage :header="header" :tabs="tabs" v-model:activeTab="activeTab">

        <!-- Wizard Sessions -->
        <template #tab-overview>
            <slot name="overview" :rows="rows" :loading="loading" :select="selectRow" />
        </template>

        <!-- Start Wizard -->
        <template #tab-create>
            <slot name="create" :createModel="createModel" :create="create" />
        </template>

        <!-- Preview -->
        <template #tab-inspect>
            <slot name="inspect" :selected="selected" :model="editModel" :update="update" />
        </template>

        <!-- Running Modules -->
        <template #tab-running>
            <slot name="running" :rows="runningModules" :loading="runningLoading" />
        </template>

    </BasePage>

</template>

<script setup>

import { ref } from "vue"
import { useRoute } from "vue-router"

const route = useRoute()

const props = defineProps({

    rows: Array,
    loading: Boolean,

    createModel: Object,

    create: Function,
    update: Function

})

const activeTab = ref("overview")

const selected = ref(null)
const editModel = ref(null)

/*
Runtime modules
*/

const runningModules = ref([])
const runningLoading = ref(false)

const header = route.meta.header

const tabs = [

    { key: "overview", label: "Wizard Sessions" },
    { key: "create", label: "Start Wizard" },
    { key: "inspect", label: "Wizard Previews" },
    { key: "running", label: "Running Modules" }

]

function selectRow(row) {

    selected.value = row
    editModel.value = { ...row }

    activeTab.value = "inspect"

}

</script>